export default function DevicesRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('devices2', {
      url: '/devices',
      template: require('./devices.html'),
      ncyBreadcrumb: {
        label: "{{'Devices' | translate}}"
      },
      redirectTo: 'devices2.base',
      requiredFeatures: ['devices']
    })
    .state('devices2.base', {
      url: '',
      template: require('./list/list.html'),
      controller: 'DevicesListController',
      ncyBreadcrumb: {
        label: "{{'Devices' | translate}}"
      },
      requiredFeatures: ['devices']
    })
    .state('devices2.serial', {
      url: '/serial/{serialId}',
      resolve: {
        serial: function ($stateParams, $state, InstallationsService) {
          'ngInject';
          return InstallationsService.getInstallations(1, null, 0, $stateParams.serialId).then(result => {
            if (result.data.length > 0) {
              return $state.go('devices2.detail', { installationId: result.data[0].id });
            } else {
              return $state.go('devices2');
            }
          });
        }
      }
    })
    .state('devices2.detail', {
      url: '/{installationId}',
      template: require('./view/view.html'),
      controller: 'DevicesDetailController',
      ncyBreadcrumb: {
        label: '{{installation.device.serialNumber}}',
        parent: 'devices2.base'
      },
      requiredFeatures: ['devices']
    })

    .state('devices2.activations', {
      url: '/activation',
      template: '<ui-view></ui-view>',
      controller: 'DevicesActivationsController',
      ncyBreadcrumb: {
        skip: true
      },
      requiredFeatures: ['devices.activate']
    })
    .state('devices2.activations.single', {
      url: '/single',
      helpState: 'devices2.activations',
      template: require('./activations/single/single.html'),
      controller: 'DevicesActivationsWizardController',
      ncyBreadcrumb: {
        label: "{{'Single Activation' | translate}}"
      },
      requiredFeatures: ['devices.activate.single']
    })
    .state('devices2.activations.bulk', {
      url: '/bulk',
      helpState: 'devices2.activations',
      templateUrl: 'pages/devices/activations/bulk/bulk.html',
      controller: 'DeviceActivationsBulkController',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: "{{'Bulk Activation' | translate}}"
      },
      requiredFeatures: ['devices.activate.bulk']
    })
    .state('devices2.activations.custom', {
      url: '/bulk-activation',
      helpState: 'devices2.activations',
      templateUrl: 'pages/devices/activations/bulk-custom/bulk-custom.html',
      controller: 'DeviceActivationsBulkCustomController',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: "{{'Bulk Activation' | translate}}"
      },
      requiredFeatures: ['devices.activate.custom']
    });
}
